import React from 'react'
import Icon from 'react-icon-base'

const ResponsesIcon = props => (
  <Icon viewBox="0 0 40 40" {...props}>
    <g>
      <g>
        <path d="m22.7 28.6l2.1 1.4c-0.4 1.6-2.3 2.5-4.1 2.5h-7c-0.7 0-0.9 0.2-1.1 0.2l-4.1 3.6v-3.8h-1.2c-2.1 0-3.8-1.2-3.8-3.2v-10.1c0-1.9 1.6-3.5 3.6-3.5h0.1v7.9c0 2.6 2.3 4.6 5 4.6h9.2c0.8 0 1.1 0.2 1.3 0.4z m8.4-24.8c2.7 0 4.9 2.1 4.9 4.6v13.2c0 2.5-2.2 4.7-4.9 4.7h-1.3v5l-5.9-4.7c-0.2-0.2-0.6-0.3-1.3-0.3h-7.9c-2.8 0-4.9-2.2-4.9-4.7v-13.2c0-2.5 1.6-4.7 4.3-4.7h17z" />
      </g>
    </g>
  </Icon>
)

export default ResponsesIcon
